//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum ComplianceStatusEnum {
    NotSigned = 1,
    ToDo = 2,
    Signed = 3,
    InProgress = 4,
    QualifiedNotSigned = 5,
    Qualified = 6,
    SentPartial = 7,
    SentFull = 8,
    SuspendedQualified = 9,
    SuspendedInProgress = 10,
    ClientPendingItemS = 11,
    MissingSubmittalRequirements = 12,
    MissingClientRequirements = 13,
    CompliantPendingOrientation = 14,
    ClearedToStartPendingOrientation = 15,
    NeedsReview = 16,
    VmsClientCleared = 17,
}